import { Box } from "@mui/material"

const ResultContent: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <>
        <Box position="fixed" top="72px" right="0px" zIndex={99} maxWidth="480px" width="33vw" minWidth="480px">
        { children }
        </Box>
    </>
}

export default ResultContent